import React from "react";
import BasePanel from "../base-panel";
import "./success-panel.scss";

const SuccessPanel = props => {
    return <BasePanel {...props} _class="success-panel" />;
};

export default SuccessPanel;
